/* AUTO-GENERATED by scripts/build-content.ts — do not edit by hand.
   Edit the source content/ files and re-run `tsx scripts/build-content.ts`
   (runs automatically on predev / prebuild). */

import type { PressItem } from '../types/newsContent'

export const pressItems: PressItem[] = [
  {
    "id": "kspost-2026-09",
    "date": "2026-09-10",
    "outlet": "Korea Startup Post",
    "image": "/images/press/climate-tech-final-pitch-2026.webp",
    "url": {
      "en": "https://www.kspost.biz/en-us/articles/2918",
      "ko": "https://www.kspost.biz/ko-kr/articles/2918"
    },
    "title": {
      "en": "From CO2-Eating Microbes to Carbon-Free Thermal Storage, GIGAette and The Origin Win Top Innovation Award at 'Everyone's Challenge: Climate Tech'",
      "ko": "CO2 먹는 미생물부터 무탄소 열저장까지…'모두의 챌린지 기후테크' 최고혁신상에 기가에떼·The Origin"
    }
  },
  {
    "id": "shinailbo-2025-11",
    "date": "2025-11-27",
    "outlet": "Shin-A Ilbo",
    "outletLogo": "/logo/shinailbo_logo.png",
    "image": "https://www.shinailbo.co.kr/news/photo/202511/2153177_1250557_2633.jpg",
    "url": {
      "en": "https://www.shinailbo.co.kr/news/articleView.html?idxno=2153177",
      "ko": "https://www.shinailbo.co.kr/news/articleView.html?idxno=2153177"
    },
    "title": {
      "en": "Daejeon Creative Economy Innovation Center and GIGAette to Expand Thermal Energy Storage Innovation and Global Market",
      "ko": "대전창조경제혁신센터, ㈜기가에떼 열에너지 저장 혁신과 글로벌 시장 본격 확대"
    }
  },
  {
    "id": "maeil-2025-11-26",
    "date": "2025-11-26",
    "outlet": "Maeil Business Newspaper",
    "image": "https://pimg.mk.co.kr/news/cms/202511/26/news-p.v1.20251126.2b61536cb58f478c85cb3b4cc8148393_P1.png",
    "url": {
      "en": "https://www.mk.co.kr/news/business/11477644",
      "ko": "https://www.mk.co.kr/news/business/11477644"
    },
    "title": {
      "en": "Zetron, KAIST's \"GIGAette\" and Deeptech-based \"Carbon Neutrality\" Innovation Collaboration",
      "ko": "제트론, KAIST '기가에떼'와 딥테크 기반 '탄소중립' 혁신 협업"
    }
  },
  {
    "id": "unicorn-2025-11-26",
    "date": "2025-11-26",
    "outlet": "Unicorn Factory",
    "image": "https://thumb.mt.co.kr/06/2025/11/2025112616070996499_1.jpg/dims/optimize/?1764154812",
    "url": {
      "en": "https://www.unicornfactory.co.kr/article/202511261610670996499",
      "ko": "https://www.unicornfactory.co.kr/article/202511261610670996499"
    },
    "title": {
      "en": "\"Carbon and Energy in Endless Circulation Inside the Factory\"... Zetron-GIGAette Partnership",
      "ko": "\"공장 내에서 탄소와 에너지를 무한순환\"...제트론-기가에떼 맞손"
    }
  },
  {
    "id": "djenews-2025-11",
    "date": "2025-11-16",
    "outlet": "Daejeon Economic News",
    "outletLogo": "/logo/djenews_logo.png",
    "image": "https://cdn.djenews.co.kr/news/photo/202511/243826_264765_1531.jpg",
    "url": {
      "en": "https://www.djenews.co.kr/news/articleView.html?idxno=243826",
      "ko": "https://www.djenews.co.kr/news/articleView.html?idxno=243826"
    },
    "title": {
      "en": "GIGAette Expands Full-Scale Thermal Energy Storage Innovation and Global Market Entry",
      "ko": "㈜기가에떼, 열에너지 저장 혁신과 글로벌 시장 본격 확대"
    }
  },
  {
    "id": "bloter-2025-09",
    "date": "2025-09-14",
    "outlet": "Bloter",
    "outletLogo": "/logo/bloter_logo.png",
    "image": "https://cdn.bloter.net/news/photo/202509/643901_252546_4415.jpg",
    "url": {
      "en": "https://www.bloter.net/news/articleView.html?idxno=643901",
      "ko": "https://www.bloter.net/news/articleView.html?idxno=643901"
    },
    "title": {
      "en": "GIGAette Raises 900 Million Won Seed Funding, Shinhan Venture Investment and Blue Point Partners Participate",
      "ko": "기가에떼 9억 시드 투자 유치, 신한벤처투자·블루포인트 참여"
    }
  },
  {
    "id": "news1-2025-09",
    "date": "2025-09-11",
    "outlet": "News1",
    "image": "https://www.news1.kr/_next/image?url=https%3A%2F%2Fi3n.news1.kr%2Fsystem%2Fphotos%2F2025%2F9%2F11%2F7489619%2Fhigh.jpg&w=1920&q=75",
    "url": {
      "en": "https://www.news1.kr/industry/sb-founded/5908747",
      "ko": "https://www.news1.kr/industry/sb-founded/5908747"
    },
    "title": {
      "en": "Thermal Battery Development Startup GIGAette Raises 900 Million Won Seed Funding",
      "ko": "열배터리 개발 스타트업 기가에떼, 9억 규모 시드투자 유치"
    }
  },
  {
    "id": "venturesquare-2025-09",
    "date": "2025-09-11",
    "outlet": "Venture Square",
    "outletLogo": "/logo/venture_square_logo.png",
    "image": "https://www.venturesquare.net/wp-content/uploads/2025/09/rlrk.jpg",
    "url": {
      "en": "https://www.venturesquare.net/1004149",
      "ko": "https://www.venturesquare.net/1004149"
    },
    "title": {
      "en": "GIGAette Raises 900 Million Won Seed Funding... Shinhan Venture Investment and Blue Point Partners Participate",
      "ko": "기가에떼, 9억 원 시드 투자 유치.. \"신한벤처투자-블루포인트 등 참여\""
    }
  },
  {
    "id": "moneytoday-2025-09",
    "date": "2025-09-11",
    "outlet": "Money Today",
    "outletLogo": "/logo/money_today_logo.svg",
    "image": "https://thumb.mt.co.kr/cdn-cgi/image/f=avif/21/2025/09/2025091110595557181_1.jpg",
    "url": {
      "en": "https://mt.co.kr/future/2025/09/11/20250911110595557181",
      "ko": "https://mt.co.kr/future/2025/09/11/20250911110595557181"
    },
    "title": {
      "en": "Thermal Energy Storage Instead of Electricity... GIGAette Raises 900 Million Won Seed Funding",
      "ko": "전기 대신 열 에너지 저장...기가에떼, 9억 시드투자 유치"
    }
  },
  {
    "id": "moneytoday-2023-11-23",
    "date": "2023-11-23",
    "outlet": "Money Today",
    "outletLogo": "/logo/money_today_logo.svg",
    "image": "https://thumb.mt.co.kr/cdn-cgi/image/f=avif/21/2023/11/2023112314224596254_1.jpg",
    "url": {
      "en": "https://mt.co.kr/future/2023/11/23/20231123142429654",
      "ko": "https://mt.co.kr/future/2023/11/23/20231123142429654"
    },
    "title": {
      "en": "\"Energy Storage with Salt\" GIGAette, K-Tech Startup at Yangjungchang Award Ceremony",
      "ko": "소금으로 에너지 저장' 기가에떼, K테크 스타트업 양중창 장창성"
    }
  },
  {
    "id": "moneytoday-2023-11-17",
    "date": "2023-11-17",
    "outlet": "Money Today",
    "outletLogo": "/logo/money_today_logo.svg",
    "image": "https://thumb.mt.co.kr/cdn-cgi/image/f=avif/21/2023/11/2023111509140532225_1.jpg",
    "url": {
      "en": "https://mt.co.kr/future/2023/11/17/20231115091405322225",
      "ko": "https://mt.co.kr/future/2023/11/17/20231115091405322225"
    },
    "title": {
      "en": "Bill Gates Also Invested in Thermal Energy Storage... Korean TES New Technology Emerges",
      "ko": "빌게이츠도 투자한 열에너지 저장장치...한국형 TES 신기술 뜬다"
    }
  }
]
